/** Shown while a lazily-loaded route chunk is downloading. */
export default function RouteFallback() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center" role="status" aria-live="polite">
      <div
        className="h-8 w-8 animate-spin rounded-full border-2 border-gray-300 border-t-[#1E3A2E]"
        aria-hidden="true"
      />
      <span className="sr-only">Loading</span>
    </div>
  );
}
